export default __webpack_public_path__ + "static/media/Coils of the Dragon King.8f63f8fa.jpg";